import { Flex } from "antd";
import { styled } from "styled-components";
import { ItemCardHeader } from "./ItemCardHeader";
import { radius } from "@libertify/ui";

export const ListItemCard = ({
  children,
  title,
  onEditClick,
  recordId,
  resource,
  invalidationResource,
  style,
}: {
  children: React.ReactNode;
  title: string;
  onEditClick: () => void;
  recordId: string;
  resource: string;
  invalidationResource?: string;
  style?: React.CSSProperties;
}) => {
  return (
    <StyledItemCard
      vertical
      gap={10}
      style={{ padding: 10, cursor: "pointer", ...style }}
      onClick={onEditClick}
    >
      <ItemCardHeader
        title={title}
        onEditClick={onEditClick}
        recordId={recordId}
        resource={resource}
        invalidationResource={invalidationResource}
      />
      {children}
    </StyledItemCard>
  );
};

export const StyledItemCard = styled(Flex)`
  background-color: ${(props) => `${props.theme.colorInfoBg}80`};
  border: 1px solid ${(props) => props.theme.colorBorder};
  border-radius: ${radius.box}px;
`;
